export default {
  SET_USERS(state, data) {
    state.users = data;
  },
  SET_PAGING(state, data) {
    state.pageable = data;
  },
  SET_USER(state, data) {
    state.user = data;
  },
  SET_LICENSE_DATA(state, data) {
    state.userLicenseData = data;
  },
  SET_USER_PICTURE_URL(state, data) {
    state.userPictureUrl = data;
  },
}
